export {};

const toggleTipDisplay = ($block) => {
    const $wrapper = $block.closest('.js-scrolling-wrp');
    const $content = $wrapper.find('.js-scrolling-cnt');

    if (!$wrapper.length || !$content.length) {
        return;
    }

    if ($content.width() <= $wrapper.width()) {
        $block.css('display', 'none');
    }
};

if ($('.table__wrap').find('.js-touch-tip').length === 0) {
    $('.table__wrap').append('<div class="governance-scheme__touch-tip js-touch-tip" data-parent="governance-scheme"><svg class="svg-symbol svg-symbol--touch-tip"><use xlink:href="#svg-symbol--touch-tip"/></svg></div>')
}
$('.js-touch-tip').each(function eachSection(touchTipIndex, Block) {
    const $block = $(Block);
    const parentClassName = $block.data('parent');
    const $parentTouch = $block.closest('.' + parentClassName);

    let ts;

    $parentTouch.on('touchstart', function(evt) {
        ts = evt.originalEvent.touches[0].clientX;
    });

    $parentTouch.on('touchend', function(evt) {
        const te = evt.originalEvent.changedTouches[0].clientX;

        if (ts > te + 30) {
            $block.fadeOut(300);
        } else if (ts < te - 30) {
            $block.fadeOut(300);
        }
    });

    toggleTipDisplay($block);
});

$('.table__wrap, .table-wrap, .distribution__wrapper').on('touchstart click', function(evt) {
    $(this).children('.js-touch-tip').hide();
});



// WEBPACK FOOTER //
// ./js/main/module/js-touch-tip.js